import IWallMetaData from 'components/interfaces/IWallMetaData';
import { HubConnectionBuilder } from '@microsoft/signalr';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import { setWall, setWallMetaData } from 'store/selectedWall/actions';
import { setRegeneratingDownloads } from 'store/configurationSidebar/actions';
import store from 'store/store';
import IWall from 'components/interfaces/IWall';
import { configurationChanged } from 'store/configurationChange/actions';
import getDefaultWall from './services/getDefaultWall';
import placeGlasses from './modals/src/glassWall/placeGlasses';
import doWallPreSaveActions from './modals/src/glassWall/doWallPreSaveActions';
import getDefaultWallMetaData from './services/getDefaultWallMetaData';
import getDefaultGlassAreaMetaData from './services/getDefaultGlassAreaMetaData';
import { THREE_D } from './types/dimensions';
import getDefaultGlassWallDoor from './modals/src/glassWall/doors/getDefaultGlassWallDoor';
import glassWallPartTypes from './types/glassWallPartTypes';
import getDefaultDoorMetaData from './services/getDefaultDoorMetaData';
import getDefaultGlassArea from './modals/src/glassWall/glassAreas/getDefaultGlassArea';

export default async (
  setDimensionStatus: (dimension: string) => void
): Promise<void> => {
  const connection = new HubConnectionBuilder().withUrl('/ws').build();

  connection.on('downloads-generation-finished', () => {
    store.dispatch(setRegeneratingDownloads(false));
  });

  connection.on('place-wall', (jsonWall: string) => {
    try {
      const partialWall = JSON.parse(jsonWall) as IWall;
      console.log('FROM ENDPOINT', partialWall);

      const wall: IWall = {
        ...getDefaultWall(),
        ...partialWall,
      };
      wall.parts = (partialWall.parts ?? []).map((part) => {
        if (part.type === glassWallPartTypes.door) {
          return {
            ...getDefaultGlassWallDoor(Math.random() * 999999999, wall),
            ...part,
          };
        }

        return part;
      });

      store.dispatch(setWall(wall));

      store.dispatch(configurationChanged());

      let wallLineId = '';
      window.SetCurrentPickedObject('WallLine');
      if (window.GetCurrentPickedObject() == null) {
        window.SetCurrentPickedObject('connection');

        const twoDObjectsBeforeAdd = [...window.all2dObjects];
        window.AddWallLineAndConnection(wall);
        const twoDObjectsAfterAdd = [...window.all2dObjects];

        const created = twoDObjectsAfterAdd
          .filter((object) => !twoDObjectsBeforeAdd.includes(object))
          .map((object) => object.split(' '))
          .filter((parts) => parts[0] === 'WallLine');

        if (created.length === 0) {
          // eslint-disable-next-line no-throw-literal
          throw "It didn't create anything :(";
        }

        // eslint-disable-next-line prefer-destructuring
        wallLineId = created[0][1];
      } else {
        const wallLine = window.GetCurrentPickedObject();
        wallLineId = wallLine.properties.wallID;

        window.SetToggleStatus('2d');

        window.EditWallLineAndConnection(wall);
      }

      const doors = wall.parts.filter((part): part is IGlassWallDoor => {
        return part.type === glassWallPartTypes.door;
      });

      const doorsMetaData = doors.map((door) => {
        return { ...getDefaultDoorMetaData(), doorId: door.doorID };
      });

      const glassAreasCount =
        doors.length +
        1 -
        doors.filter((door) => door.isFirstDoor || door.isLastDoor).length;

      const metaData: IWallMetaData = {
        ...getDefaultWallMetaData(),
        identifier: wallLineId,
        glassAreas: Array.from({ length: glassAreasCount }, (_, index) => {
          return { ...getDefaultGlassAreaMetaData(), index };
        }),
        doors: doorsMetaData,
      };
      store.dispatch(setWallMetaData(metaData));

      window.SetToggleStatus('3d');

      window.SetCurrentPickedObject('WallLine');
      const parts = placeGlasses(
        wall,
        Array.from({ length: glassAreasCount }, () => getDefaultGlassArea())
      );
      window.UpdateGlassWall(doWallPreSaveActions(wall), parts);

      setDimensionStatus(THREE_D);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  });

  await connection.start();
};
